module.exports = __webpack_public_path__ + "static/media/shopify4.1ac59e94.png";